import Cookies from '@/services/cookies'

const COSMETIC_DISCOUNT_CMZ = 'dWr3'
const TINKOFF_CMZ = 'kjAe'
const CASHBACK_CMZ = 'QpVM'
const EXPRESS_DELIVERY_CMZ = 'gP7J'
const CUSTOM_WELCOME_SET_CMZ = 'wZ09'
const FIZIKL_CMZ = 'KdMo'

export default {
  specificQueryParams: state => state.specificQueryParams,
  isBasketCashbackVisible: (state) => Cookies.get('cmz') !== CASHBACK_CMZ && state.specificQueryParams.cmz !== CASHBACK_CMZ,
  isCosmeticDiscountVisible: (state, getters, rootState, rootGetters) => (Cookies.get('cmz') === COSMETIC_DISCOUNT_CMZ || state.specificQueryParams.cmz === COSMETIC_DISCOUNT_CMZ) && (!rootGetters['client/isLoggedIn'] || rootGetters['client/isNewClient']),
  isExpressDeliveryVisible: (state) => (Cookies.get('cmz') === EXPRESS_DELIVERY_CMZ || state.specificQueryParams.cmz === EXPRESS_DELIVERY_CMZ),
  isExpressDeliverySelected: (state, getters) => state.isExpressDeliverySelected && getters.isExpressDeliveryVisible,
  isWelcomeSetVisible: (state, getters, rootState, rootGetters) => (!rootGetters['client/isLoggedIn'] || rootGetters['client/isNewClient']) && !(Cookies.get('cmz') === TINKOFF_CMZ || state.specificQueryParams.cmz === TINKOFF_CMZ),
  isNewMobDesignGoals: (state, getters, rootState, rootGetters) => (!rootGetters['client/isLoggedIn'] || rootGetters['client/isNewClient']),
  isCustomWelcomeSet: (state) => (Cookies.get('cmz') === CUSTOM_WELCOME_SET_CMZ || state.specificQueryParams.cmz === CUSTOM_WELCOME_SET_CMZ),
  isCustomLanding: (state) => Cookies.get('cmz') || state.specificQueryParams.cmz,
  isFizikl: (state) => Cookies.get('cmz') === FIZIKL_CMZ || state.specificQueryParams.cmz === FIZIKL_CMZ,
}
